import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Shared horizontal gutters for page content and header insets */
export const PAGE_GUTTERS = 'px-4 sm:px-6 lg:px-8 2xl:px-12';

/** Fluid up to ~1920px so tables and dashboards use large monitors */
export const PAGE_MAX_WIDTH = 'max-w-[120rem]';

/** Break out of a padded parent to span the viewport (e.g. full-width section headers) */
export const pageBleedXClass =
  'relative left-1/2 w-screen max-w-[100vw] -translate-x-1/2';

export const pageContainerClass = cn(
  'mx-auto w-full min-w-0',
  PAGE_MAX_WIDTH,
  PAGE_GUTTERS,
  'py-6'
);

export type PageContainerSize = 'default' | 'wide' | 'narrow' | 'full';

const sizeClasses: Record<PageContainerSize, string> = {
  default: PAGE_MAX_WIDTH,
  wide: 'max-w-6xl',
  narrow: 'max-w-2xl',
  full: 'max-w-none',
};

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  size?: PageContainerSize;
  /** Omit default vertical padding (when the shell already applies it) */
  noPadding?: boolean;
}

export function PageContainer({
  children,
  className,
  size = 'default',
  noPadding = false,
}: PageContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full min-w-0',
        sizeClasses[size],
        PAGE_GUTTERS,
        !noPadding && 'py-6',
        className
      )}
    >
      {children}
    </div>
  );
}

export default PageContainer;
